import React, { useState } from 'react'
import { Typography, Box, Icon } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'

const LearnMoreModal = () => {
  const [modalState, setModalState] = useState(false)

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        onClick={handleOpen}
        variant="subtitle2"
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          color: 'alternate.main',
        }}
      >
        Learn More
      </Typography>

      <AdxFormModal
        title="Requesting Leave Credit"
        icon={<Icon>info</Icon>}
        iconColor="info.main"
        open={modalState}
        onClose={handleClose}
        handleClose={handleClose}
        sxModal={{ maxWidth: 350 }}
      >
        <Typography variant="subtitle1">
          Get approval letter from management before working on non-working days.
          <br />
          Provide approval letter with relevant details afterwards to request for replacement leave
          credit.
        </Typography>
      </AdxFormModal>
    </Box>
  )
}

export default LearnMoreModal
